import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { OpsReviewApi, opsReviewApiRef } from "./api/OpsReviewApi";

import { rootRouteRef } from "./routes";

export const opsReviewPlugin = createPlugin({
  id: "ops-review",
  apis: [
    createApiFactory({
      api: opsReviewApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new OpsReviewApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const OpsReviewPage = opsReviewPlugin.provide(
  createRoutableExtension({
    name: "OpsReviewPage",
    component: () =>
      import("./views/OpsReviewPage/OpsReviewPage").then(
        (m) => m.OpsReviewPage
      ),
    mountPoint: rootRouteRef,
  })
);
